import React, { Fragment } from "react";
import "./config/reactotron";
import { Provider } from "react-redux";
import store from "./store";
import "./styles/global";
import "./styles/utils";
import Routes from "./routes";
import Error from "./components/Error";
import Success from "./components/Success";
import moment from "moment";
moment.locale("pt-br", {
  months: "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
    "_"
  ),
  monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
  weekdays: "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split(
    "_"
  ),
  weekdaysShort: "dom_seg_ter_qua_qui_sex_sáb".split("_"),
  weekdaysMin: "dom_2ª_3ª_4ª_5ª_6ª_sáb".split("_"),
  longDateFormat: {
    LT: "HH:mm",
    L: "DD/MM/YYYY",
    LL: "D [de] MMMM [de] YYYY",
    LLL: "D [de] MMMM [de] YYYY [às] LT",
    LLLL: "dddd, D [de] MMMM [de] YYYY [às] LT"
  },
  calendar: {
    sameDay: "[Hoje às] LT",
    nextDay: "[Amanhã às] LT",
    nextWeek: "dddd [às] LT",
    lastDay: "[Ontem às] LT",
    lastWeek: function() {
      return this.day() === 0 || this.day() === 6
        ? "[Último] dddd [às] LT" // Saturday + Sunday
        : "[Última] dddd [às] LT"; // Monday - Friday
    },
    sameElse: "L"
  },
  relativeTime: {
    future: "em %s",
    past: "%s",
    s: "1s",
    m: "1min",
    mm: "%dmin",
    h: "1h",
    hh: "%dh",
    d: "1d",
    dd: "%dd",
    M: "1m",
    MM: "%dm",
    y: "1a",
    yy: "%da"
  },
  ordinal: "%dº"
});

const App = () => (
  <Provider store={store}>
    <Fragment>
      <Error />
      <Success />
      <Routes />
    </Fragment>
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js